/** @jsxImportSource @emotion/react **/
import React, { FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";

import { LANG_ALL, styleContainer } from "../../../pages/utils";
import { Context } from "../../../context/BannerContext";
import { BaseInput, Text } from "../../atoms";
import { ContentSection } from "../../organisms";
import MediaField from "../MediaField";
import * as styles from "../Header/index.styles";

const BannerForm: FC = () => {
  const {
    formData,
    handleChangeFormData: handleChange,
    handleUpdateFormData: handleData,
  } = useContext(Context);

  const { id } = useParams();

  const detail_data = useSelector((state: any) => state.get_banners.data);
  const news_data = id ? detail_data?.data.find((r: any) => r.id === id) : null;

  const langInit = news_data?.lang
    ? { value: news_data.lang, label: news_data.lang }
    : { value: "", label: "" };

  const [isTitleValid, setTitleValid] = useState<boolean>(false);
  const [isHrefValid, setHrefValid] = useState<boolean>(false);

  useEffect(() => {
    if (!!id) {
      handleData(news_data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, news_data]);

  useEffect(() => {
    setTitleValid(formData.title.length > 2);
  }, [formData.title]);

  useEffect(() => {
    setHrefValid(formData.href.length > 0);
  }, [formData.href]);

  const handleLang = (e: any) => {
    handleChange({ lang: e.value });
  };

  return (
    <ContentSection
      style={styleContainer}
      header={
        <React.Fragment>
          <Text textType="h4" weight="black">
            {id ? "Editar" : "Nuevo"} banner
          </Text>
        </React.Fragment>
      }
    >
      <BaseInput
        label="Título"
        value={formData.title}
        onChange={(value) => handleChange({ title: value })}
        placeholder="Escribe el título del banner"
        maxLength={500}
        error={!isTitleValid && formData.title.length > 0}
        success={isTitleValid}
        hint={
          !isTitleValid && formData.title.length > 0
            ? "Digite más de dos letras"
            : ""
        }
      />

      <BaseInput
        label="Ir a"
        value={formData.href}
        onChange={(value) => handleChange({ href: value })}
        placeholder="Escribe la ruta del botón"
        maxLength={500}
        error={!isHrefValid && formData.href.length > 0}
        success={isHrefValid}
        hint={
          !isHrefValid && formData.href.length > 0
            ? "Digite más de una letra"
            : ""
        }
      />

      <MediaField
        label="Imagen del banner"
        value={formData.image}
        folder="banners"
        onChange={(url) => handleChange({ image: url })}
      />

      <Text textType="label">
        IDIOMA:{" "}
        <Select
          css={styles.input}
          options={LANG_ALL}
          defaultValue={langInit}
          onChange={(e) => handleLang(e)}
        />
      </Text>
    </ContentSection>
  );
};

export default BannerForm;